export enum WorkWeekDays {
  FirstDay = 1,
  SecondsDay = 2,
  ThirdDay = 3,
  FourthDay = 4,
  FifthDay = 5,
  SixthDay = 6,
}
